import { createAsyncThunk } from "@reduxjs/toolkit";
import { objectsKiiAPI } from "libs/apiClient/ObjectsKii";
import { inapplicabilityReasonsAPI } from "libs/apiClient/InapplicabilityReasons";

export const getCategorisingList = createAsyncThunk(
	"selectionCategoriesSlice/getCategorisingList",
	async (objId: number, { rejectWithValue }) => {
		try {
			return await objectsKiiAPI.categorisingDetail(objId).then((r) => r.data);
			// return (await $api(`/objects_kii/${objId}/categorising`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const setCategorisingList = createAsyncThunk(
	"selectionCategoriesSlice/setCategorising",
	async (
		body: {
			objId: string | undefined;
			newList: {
				id: number;
				firstCatStatus: boolean;
				inapplicabilityReason: any;
				organizationObject: any;
				result: string;
				secondCatStatus: boolean;
				significanceCriteria: any;
				thirdCatStatus: boolean;
			}[];
		},
		{ rejectWithValue },
	) => {
		try {
			return await objectsKiiAPI.categorisingCreate(+body?.objId!, body.newList).then((r) => r.data);
			// return (await $api.post(`/objects_kii/${body.objId}/categorising`, body.newList)).data;
		} catch ({ message }) {
			return rejectWithValue({ message });
		}
	},
);

export const getReasons = createAsyncThunk("stepFiveSlice/getReasons", async (_, { rejectWithValue }) => {
	try {
		return await inapplicabilityReasonsAPI.inapplicabilityReasonsList().then((r) => r.data);
		// return(await $api("/inapplicability_reasons")).data;
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});
